import * as React from 'react';
import c from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Loading.css';
import { LOADINGTEXT } from '../../lib/labels';

export const Loading = ({ whatIsLoading, smallLoader, extraSmallLoader, showSuffix = true }) => (
  <div className={c(
    styles.loading, 
    'loading',
    {[styles.small]: smallLoader},
    { [styles['extra-small']]: extraSmallLoader},
  )}>
    <FontAwesomeIcon icon={['fas', 'circle-notch']} className={styles.icon} spin />
    {whatIsLoading}{showSuffix && <> {LOADINGTEXT.CONTENT}</>}
  </div>
);